import React, { forwardRef, useState } from "react";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import NotesImages from "../../images/notes-image.svg";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import useBDocTranslator from "../hooks/useBDocTranslator";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  VisibilityOffIcon: forwardRef((props, ref) => (
    <VisibilityOffIcon {...props} ref={ref} />
  )),
  VisibilityIcon: forwardRef((props, ref) => (
    <VisibilityIcon {...props} ref={ref} />
  )),
};

function Consultations(props) {
  const [noteVisible, setNoteVisible] = useState(false);
  const { t } = useBDocTranslator();

  return (
    <div style={{ maxWidth: "100%" }}>
      <MaterialTable
        columns={[
          { title: t("Appointment Type"), field: "event_type" },
          {
            title: t("Appointment Date"),
            field: "appt_date_start",
            type: "datetime",
          },
          { title: t("Healthcare Provider"), field: "providerName" },
          { title: t("Consultation Notes"), field: "note" },
        ]}
        data={props.data}
        title={t("Consultation Notes")}
        icons={tableIcons}
        options={{
          headerStyle: {
            backgroundColor: "#01579b",
            color: "#FFF",
          },
          actionsColumnIndex: -1,
          tableLayout: "auto",
          responsive: "simple",
          overflowX: "auto",
          overflowY: "auto",
          maxBodyHeight: "400px",
          minBodyHeight: "200px",
          paging: true,
          pageSize: 10,
          pageSizeOptions: [5, 10, 20, 50],
          search: true,
          showTitle: true,
          toolbar: true,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: (
              <span>
                <img style={{ width: "15%" }} src={NotesImages} alt="" />
              </span>
            ),
          },
        }}
        actions={[
          {
            icon: (rowData) =>
              rowData.visibility === "public" ? (
                <VisibilityIcon />
              ) : (
                <VisibilityOffIcon />
              ),
            tooltip: "Toogle Visible",
            onClick: (e, row) => {
              console.log(row);
              props.handleVisibility(
                row.id,
                row.visibility === "public" ? "private" : "public"
              );
            },
            disabled: props.section === "patient",
          },
        ]}
      />
    </div>
  );
}

export default Consultations;
